import React, { useCallback } from 'react';
import Pagination from '@mui/material/Pagination';
import { Theme, useMediaQuery } from '@mui/material';

export default function GridPagination({
	page,
	pageCount,
	onChange,
	loading,
}: { page: number, pageCount: number; loading: boolean; onChange: (page: number) => void }) {
	const callback = useCallback((_: any, newPage: number) => {
		onChange(newPage)
	}, [onChange])
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return (
		<Pagination
			className='self-end'
			page={page}
			disabled={loading}
			count={pageCount}
			onChange={callback}
			boundaryCount={isMobile ? 0 : 3}
			sx={{
				'& .MuiPagination-ul': {
					borderColor: 'common.borderPrimary',
					borderRadius: 0,
					borderRight: 0,
				},
				'& .MuiPagination-ul li': {
					borderColor: 'common.borderPrimary',
				},
				'& .MuiPagination-ul li button, & .MuiPaginationItem-ellipsis': {
					color: 'common.textPrimary',
					fontFamily: 'inherit',
					fontWeight: 400,
					fontSize: 16,
				},
				'& .MuiPagination-ul li button:hover': {
					backgroundColor: 'common.backgroundPrimary',
				},
				'& .Mui-selected': {
					backgroundColor: (theme) => theme.palette.common.backgroundPrimary + ' !important',
				},
			}}
		/>
	);
}
